<template>
  <div class="el-form-item item insurance subform">
    <label for="time" class="el-form-item__label tit_label" :style="labelWidth ? `width: ${labelWidth}` : ''">
      {{ config.label }}
    </label>
    <el-collapse class="el-form-item__content" @change="handleChange">
      <el-collapse-item class="content">
        <el-row v-if="isReset">
          <el-col :span="8">
            <FormItem v-for="(c, i) in formCtrls" :key="'formItem' + i" :viewMode="viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </el-col>
          <el-col :span="16">
            <FormItem v-for="(c, i) in dateCtrl" :key="'formItem1' + i" :viewMode="viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
            <FormItemRemind :config="remindCtrl" :options1="options1" :options2="options2"
              :inputValue="form[remindCtrl.key1]" :inputValue2="form[remindCtrl.key2]" :viewMode="viewMode"
              :labelWidth="'180px'" @onChange="onChange" />
            <FormItem v-for="(c, i) in descCtrl" :key="'formItem2' + i" :viewMode="viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </el-col>
        </el-row>
        <div v-else>
          <FormItem v-for="(c, i) in formCtrls" :key="'formItem3' + i" :viewMode="viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          <FormItemRemind :config="remindCtrl" :options1="options1" :options2="options2"
            :inputValue="form[remindCtrl.key1]" :inputValue2="form[remindCtrl.key2]" :viewMode="viewMode"
            :labelWidth="'180px'" @onChange="onChange" />
        </div>
        <template slot="title">
          {{ formOpen ? "收起" : "展开" }}
          <i class="ico" :class="[formOpen ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "Insurance",
  props: {
    labelWidth: String,
    config: Object,
    form: Object,
    formCtrls: Array,
    viewMode: Boolean,
    remindCtrl: Object,
    options1: Array,
    options2: Array,
    dateCtrl: Array,
    descCtrl: Array,
    isReset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formOpen: false,
    };
  },
  methods: {
    handleChange(val) {
      this.formOpen = !!val.length;
    },
    onChange({ key, value }) {
      // console.log(key, value)
      this.$emit("onChange", {
        key,
        value,
        data: (this.config && this.config.data),
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  &.subform/deep/ {
    >.el-form-item__content {
      margin-left: 180px;

      // > .content {
      //   .el-form-item {
      //     margin-bottom: 22px;
      //   }
      // }

      &.el-collapse {
        border: 0 none;

        /deep/ .el-collapse-item__header {
          border: 0 none;
          height: 40px;
          line-height: 41px;

          .ico {
            color: #c6c6c6;
            font-size: 20px;
            margin-left: 5px;
          }
        }

        /deep/ .el-collapse-item__wrap {
          width: 100%;
          border: 0 none;
        }
      }
    }
  }
}

.tit_label {
  margin: 19px 0 17px 112px;
  text-align: left;
  font-size: 18px;
  color: #333;
}

/deep/ .el-collapse-item__header {
  margin: 20px 0 18px 112px;
  text-align: left;
  font-size: 18px;
  color: #333;
}

.el-form-item__content {
  margin-left: 0 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0 !important;
}

/deep/ .el-textarea__inner {
  font-family: "Microsoft Yahei";
}

.el-col-16 {
  margin-left: -48px;
}
</style>